import React, { useState } from 'react';

interface PanoramaConfirmationData {
  type: 'panorama_confirmation';
  justificativa?: string;
  // true só no card empurrado AO VIVO (via SSE); o card PERSISTIDO (reidratado do
  // histórico no reload) vem sem `active` → renderiza passivo, sem botões, pra não
  // re-rodar o panorama (caro) num clique acidental.
  active?: boolean;
}

interface Props {
  data: PanoramaConfirmationData;
}

/**
 * Card de confirmação do Panorama Jurídico (gate humano antes da pesquisa cara).
 * Ao vivo (active): botões disparam o evento de janela `panoramaDecision`.
 * Histórico (sem active): só o registro da proposta, sem botões.
 */
const PanoramaConfirmation: React.FC<Props> = ({ data }) => {
  const [decided, setDecided] = useState<null | 'run' | 'decline'>(null);
  const showButtons = data.active === true && decided === null;

  const decide = (decision: 'run' | 'decline') => {
    if (decided) return;
    setDecided(decision);
    window.dispatchEvent(new CustomEvent('panoramaDecision', { detail: { decision } }));
  };

  return (
    <div
      style={{
        border: '1px solid #10b981',
        borderRadius: 12,
        padding: '14px 16px',
        margin: '8px 0',
        background: 'rgba(16, 185, 129, 0.06)',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 6 }}>🔎 Rodar o Panorama Jurídico?</div>
      <div style={{ fontSize: 14, opacity: 0.85, marginBottom: data.justificativa ? 4 : 12 }}>
        Pesquisa jurídica profunda — levanta teses, fundamentos e variações por tribunal.
        Entrega resultados mais completos e precisos, mas leva alguns minutos.
      </div>
      {data.justificativa ? (
        <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 12, fontStyle: 'italic' }}>
          {data.justificativa}
        </div>
      ) : null}
      {showButtons ? (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button
            onClick={() => decide('run')}
            style={{
              padding: '8px 16px', borderRadius: 8, border: 'none',
              background: '#10b981', color: '#fff', cursor: 'pointer', fontWeight: 600,
            }}
          >
            Rodar Panorama
          </button>
          <button
            onClick={() => decide('decline')}
            style={{
              padding: '8px 16px', borderRadius: 8, border: '1px solid #94a3b8',
              background: 'transparent', color: 'inherit', cursor: 'pointer',
            }}
          >
            Agora não
          </button>
        </div>
      ) : (
        <div style={{ fontSize: 13, opacity: 0.6 }}>
          {decided === 'run'
            ? '▶ Rodando o Panorama Jurídico…'
            : decided === 'decline'
            ? '✕ Seguindo sem o Panorama, com as buscas diretas.'
            : '— proposta do Panorama registrada no histórico —'}
        </div>
      )}
    </div>
  );
};

export default PanoramaConfirmation;
